<template>
    <div class="flex flex-col gap-y-2 bg-beige px-6 py-5">
        <h4
            class="font-semibold text-base mb-2"
            v-text="title"
        />
        <p
            class="text-sm mb-2"
            v-text="description"
        />

        <div
            v-for="cookie in cookies"
            :key="cookie.id"
            class="flex items-center my-2"
        >
            <form-toggle
                :model-value="cookieStatus[cookie.id]"
                :disabled="necessary"
                @update:model-value="updateCookie(cookie.id, $event || false)"
            />

            <p class="text-sm ml-4 uppercase font-semibold">{{ cookie.title }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Cookie, CookieName } from "~/types";

defineProps<{
    cookies: Cookie[];
    title: string;
    description: string;
    necessary?: boolean;
}>();

const cookieStore = useCookieStore();
const { cookieStatus } = storeToRefs(cookieStore);

const updateCookie = (id: CookieName, checked: boolean) => {
    cookieStore.updateCookie(id, checked);
};
</script>
